<template>
    <div ref="scrollTarget">
        <slot></slot>
    </div>
</template>

<script setup>
import { ref, watch, onMounted, nextTick } from 'vue';
import { useRoute } from 'vue-router';

import { useState, useGetters } from '~coreModules/core/js/composables/vuexHelpers';

import { getDistanceFromElementToTop } from '~coreModules/browser/js/browser-utils';

import { scrollHashIds } from '~coreModules/core/js/router-constants';

import { HEADER_MODULE_NAME } from '~coreModules/header/js/header-store';
import { MODALS_MODULE_NAME } from '~coreModules/modals/js/modals-store';
import { MODAL_TRANSITION_DURATION } from '~coreModules/modals/js/modal-constants';

const route = useRoute();

const scrollTarget = ref(null);

const curationHasChanged = ref(false);
const responseIdHasChanged = ref(false);

const props = defineProps({
    catalogResponseId: {
        type: String,
        default: '',
    },
});

const { headerHeight } = useState(HEADER_MODULE_NAME, {
    headerHeight: state => state.headerHeight,
});

const { modalIsOpen } = useGetters(MODALS_MODULE_NAME, { modalIsOpen: 'isOpen' });

function scrollToTopOfCatalogActionBar() {
    if (!curationHasChanged.value) {
        const catalogActionBarScrollPosition = getDistanceFromElementToTop(scrollTarget?.value) -
            headerHeight.value;

        window.scrollTo({
            top: catalogActionBarScrollPosition,
            behavior: 'auto',
        });
    }
}

watch(() => route?.query, (toQuery, fromQuery) => {
    const toCuration = toQuery?.curation;
    const fromCuration = fromQuery?.curation;

    if (toCuration !== fromCuration) {
        curationHasChanged.value = true;
    } else {
        curationHasChanged.value = false;
    }

    if (modalIsOpen.value) {
        responseIdHasChanged.value = true;
    }

    scrollToTopOfCatalogActionBar();
}, { deep: true });

watch(() => route?.hash, (hash) => {
    if (hash === scrollHashIds.catalogActionBar) {
        scrollToTopOfCatalogActionBar();
    }
});

watch(modalIsOpen, (isOpen, wasOpen) => {
    if (!isOpen && wasOpen && responseIdHasChanged.value) {
        setTimeout(() => {
            scrollToTopOfCatalogActionBar();
            responseIdHasChanged.value = false;
        }, MODAL_TRANSITION_DURATION);
    }
});

watch(() => props.catalogResponseId, (newValue, oldValue) => {
    if (newValue !== oldValue && modalIsOpen.value) {
        responseIdHasChanged.value = true;
    }
});

onMounted(() => {
    nextTick(() => {
        const urlHash = route?.hash;

        if (urlHash === scrollHashIds.catalogActionBar) {
            scrollToTopOfCatalogActionBar();
        }
    });
});
</script>

<style lang="scss"></style>
